import { useState } from "react";
import { toast } from "sonner";
import { MailCheck, RefreshCw } from "lucide-react";
import api from "@/lib/api";

export function RsvpVerifyNotice({ email, redirect, onRefresh }) {
  const [busy, setBusy] = useState(false);
  const resend = async () => {
    setBusy(true);
    try {
      await api.post("/auth/resend-verification", { redirect });
      toast.success("Verification email sent. Check your inbox.");
    } catch { toast.error("Could not resend right now. Please try again."); }
    finally { setBusy(false); }
  };
  const check = async () => {
    const u = onRefresh ? await onRefresh() : null;
    if (u?.email_verified) toast.success("You're verified — loading your RSVP…");
    else toast.info("Not verified yet. Please click the link in your email.");
  };
  return (
    <div className="bg-white border border-[#E8E6E1] rounded-xl p-6 sm:p-8 text-center fade-up" data-testid="rsvp-verify-notice">
      <div className="w-12 h-12 rounded-full bg-[#8C9A86]/12 grid place-items-center text-[#8C9A86] mx-auto mb-4"><MailCheck size={22} /></div>
      <h2 className="font-serif text-2xl">Please verify your email</h2>
      <p className="text-sm text-stone-500 mt-2">We sent a verification link to <span className="font-medium text-stone-700">{email}</span>. Verify your email to complete your RSVP — the link brings you right back here.</p>
      <div className="mt-6 flex flex-col items-center gap-3">
        <button onClick={check} data-testid="rsvp-verify-check" className="flex items-center gap-2 rounded-full bg-[#2C2A28] text-white px-7 py-3 text-sm hover:bg-[#8C9A86] transition-colors"><RefreshCw size={15} /> I've verified my email</button>
        <button onClick={resend} disabled={busy} data-testid="rsvp-verify-resend" className="text-sm text-[#8C9A86] hover:underline disabled:opacity-50">{busy ? "Sending…" : "Resend verification email"}</button>
      </div>
    </div>
  );
}
